export default function unregisterPWA() {
  // 历史背景：之前有pwa，后来不需要了，所以每次加载都注销
  // 每次加载都注销所有 Service Worker（项目不需要 PWA）
  // todo: 先试用一段时间，后面去掉
  if ('serviceWorker' in navigator) {
    ;(async () => {
      try {
        const registrations = await navigator.serviceWorker.getRegistrations()
        for (const registration of registrations) {
          const isUnregistered = await registration.unregister()
          if (isUnregistered) {
            console.log('Service Worker 已成功注销')
          } else {
            console.log('注销 Service Worker 失败')
          }
        }
      } catch (error) {
        console.error('注销 Service Worker 时出错:', error)
      }
    })()
  }
}
